import validate from "/app/dev/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45main_45global from "/app/dev/middleware/redirect-main.global.js";
import manifest_45route_45rule from "/app/dev/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirect_45main_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}